import { ComponentProps } from 'react';
import { connect } from 'react-redux';
import { getAppLocale } from '../../../../selectors/app';
import {
    getSelectedTime,
    getTimezone,
} from '../../../../selectors/infiniteCalendarSeries/infiniteCalendarSeries';
import { CheckoutState } from '../../../../state';
import TimeSlotSelector from './TimeSlotSelector';

export type TimeSlotSelectorStateProps = {
    timezone: string;
    locale: string;
    selectedTime: string;
};

export const connectTimeSlotSelector = () =>
    connect(
        (state: CheckoutState): TimeSlotSelectorStateProps => ({
            timezone: getTimezone(state),
            locale: getAppLocale(state),
            selectedTime: getSelectedTime(state) || '',
        }),

        (
            stateProps: TimeSlotSelectorStateProps,
            ownProps: Omit<
                ComponentProps<typeof TimeSlotSelector>,
                keyof TimeSlotSelectorStateProps
            >,
        ) => ({
            ...ownProps,
            ...stateProps,
        }),
    )(TimeSlotSelector);

export const ConnectedTimeSlotSelector = connectTimeSlotSelector();

export default ConnectedTimeSlotSelector;
